export const SET_ACTIVE_SLUG = 'SET_ACTIVE_SLUG';

export const GET_AZ_LIST_REQUEST = 'GET_AZ_LIST_REQUEST';
export const GET_AZ_LIST_SUCCESS = 'GET_AZ_LIST_SUCCESS';
export const GET_AZ_LIST_FAILURE = 'GET_AZ_LIST_FAILURE';

export const GET_SEARCH_LIST_REQUEST = 'GET_SEARCH_LIST_REQUEST';
export const GET_SEARCH_LIST_SUCCESS = 'GET_SEARCH_LIST_SUCCESS';
export const GET_SEARCH_LIST_FAILURE = 'GET_SEARCH_LIST_FAILURE';

export const CLEAR_SEARCH_RESULTS = 'CLEAR_SEARCH_RESULTS';

export const GET_LIST_ITEM_PAGE_REQUEST = 'GET_LIST_ITEM_PAGE_REQUEST';
export const GET_LIST_ITEM_PAGE_SUCCESS = 'GET_LIST_ITEM_PAGE_SUCCESS';
export const GET_LIST_ITEM_PAGE_FAILURE = 'GET_LIST_ITEM_PAGE_FAILURE';

export const LIST_TAKE_AMOUNT = 12;
